import React from 'react';
import * as PropTypes from 'prop-types';

import {FormGroup} from './style';
import {Radio} from 'semantic-ui-react';

const RadioForm = ({input, data: {text, value}}) => {
    /**
     * Seta valor no redux-form.
     *
     * @returns {Promise<void>}
     */
    const handleValueInput = async () => {
        await input.onChange(value)
    };

    return (
        <FormGroup checked={input.checked} onClick={() => handleValueInput()}>
            <Radio
                {...input}
                label={text}
                onChange={() => handleValueInput()}
            />
        </FormGroup>
    )
};

RadioForm.propTypes = {
    input: PropTypes.object
};

export default RadioForm;